module.exports = __webpack_public_path__ + "images/db7ce594508cf42954a07dfa527a82ea-defaultRoomImg.png";